
<ng-container *ngIf="rndUserBanerImg ; else juicyAds">
  <a [ngClass]="{'isVertical':!targetIsHorizontal}" class="{{zoneType}}" *ngIf="targetImg!=undefined" [href]="rndUserBanerUrl ? getValidUrl(rndUserBanerUrl) : targetUrl" target="blank">
    <img [src]="rndUserBanerImg ? rndUserBanerImg : targetImg">
  </a>
</ng-container>

<ng-template #juicyAds>
  <ng-container *ngIf="zoneType == 'Mobile-Ads'">
    <script-hack
    src="https://poweredby.jads.co/js/jads.js"
    type="text/javascript"></script-hack>
    <ins id="929577" data-width="300" data-height="112"></ins>
    <script-hack type="text/javascript"> 929577 </script-hack>

  </ng-container>

  <ng-container *ngIf="zoneType == 'Mobile-Ads-2'">
    <script-hack
    src="https://poweredby.jads.co/js/jads.js"
    type="text/javascript"></script-hack>
    <ins id="929576" data-width="300" data-height="112"></ins>
    <script-hack type="text/javascript"> 929576 </script-hack>

  </ng-container>

  <ng-container *ngIf="zoneType == 'Desktop-Zone-Horizontal-Top'">

    <!-- JuicyAds v3.1 -->
    <script-hack
      src="https://poweredby.jads.co/js/jads.js"
      type="text/javascript"
    ></script-hack>
    <ins id="929769" data-width="728" data-height="102"></ins>
    <script-hack type="text/javascript"> 929769 </script-hack>

  </ng-container>

  <ng-container *ngIf="zoneType == 'Desktop-Zone-Horizontal-Bottom'">

    <!-- JuicyAds v3.1 -->
    <script-hack
      src="https://poweredby.jads.co/js/jads.js"
      type="text/javascript"
    ></script-hack>
    <ins id="936254" data-width="728" data-height="102"></ins>
    <script-hack type="text/javascript"> 936254 </script-hack>

  </ng-container>

  <ng-container *ngIf="zoneType == 'Desktop-Zone-Vertical-Left'">

    <!-- JuicyAds v3.1 -->
    <script-hack
      src="https://poweredby.jads.co/js/jads.js"
      type="text/javascript"
    ></script-hack>
    <ins id="929573" data-width="160" data-height="612"></ins>
    <script-hack type="text/javascript"> 929573 </script-hack>

  </ng-container>

  <ng-container *ngIf="zoneType == 'Desktop-Zone-Vertical-Right'">

    <!-- JuicyAds v3.1 -->
    <script-hack
      src="https://poweredby.jads.co/js/jads.js"
      type="text/javascript"
    ></script-hack>
    <ins id="936256" data-width="160" data-height="612"></ins>
    <script-hack type="text/javascript"> 936256 </script-hack>

  </ng-container>
</ng-template>
